export default __webpack_public_path__ + "static/media/bg.8c5ec34c.jpg";